import {categoryDetails as service2} from "@/content/services/2";
import {MetaTags} from "@/lib";
import {SubCategory} from "@/types";
import ServiceCategoryRow from "@/ui/service-category-row/service-category-row";
import LocalBusinessSeo from "@/lib/seo/local-business-seo";
import ContactSnippet from "@/ui/contact-snippet/contact-snippet";
import React from "react";
import {BUSINESS_NAME} from "@/content";
import ContentTitles from "@/ui/content-titles/content-titles";

export default function Service2Page() {

    return (<>
            <LocalBusinessSeo />
            <MetaTags metaTags={service2.metaTags} />
            <div className="pt-15">
                <ContentTitles
                    overline={BUSINESS_NAME}
                    title={service2.name}
                    titleComponent="h1"
                    subTitle={service2.long_name}
                />
            </div>

            {service2?.subCategories?.length && service2?.subCategories?.map((category: SubCategory, i: number) =>  <ServiceCategoryRow
                category={category}
                key={category.id}
                alternate={i % 2 === 0}
                i={i}
                showPoints
            />)}
            <ContactSnippet title={`Need more information on ${service2.name} services?`}
                            contactButtonText='Email us with your enquiries'
                            showContactButton
                            showContactInformation
            />
        </>
    )
}
